/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getFacerevealUser = /* GraphQL */ `query GetFacerevealUser($id: ID!) {
  getFacerevealUser(id: $id) {
    id
    tokens
    jobs
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFacerevealUserQueryVariables,
  APITypes.GetFacerevealUserQuery
>;
export const listFacerevealUsers = /* GraphQL */ `query ListFacerevealUsers(
  $filter: ModelFacerevealUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listFacerevealUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tokens
      jobs
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFacerevealUsersQueryVariables,
  APITypes.ListFacerevealUsersQuery
>;
export const getFacerevealJob = /* GraphQL */ `query GetFacerevealJob($id: ID!) {
  getFacerevealJob(id: $id) {
    id
    result
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFacerevealJobQueryVariables,
  APITypes.GetFacerevealJobQuery
>;
export const listFacerevealJobs = /* GraphQL */ `query ListFacerevealJobs(
  $filter: ModelFacerevealJobFilterInput
  $limit: Int
  $nextToken: String
) {
  listFacerevealJobs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      result
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFacerevealJobsQueryVariables,
  APITypes.ListFacerevealJobsQuery
>;
